module.exports = __webpack_public_path__ + "img/logros.98ab6e91.svg";